import HttpClient from "core/http";

import { REACT_APP_RESTFUL_BASE_URL_FOT_API } from "AppConfig";
import { store } from "redux-store/store";
import { logoutStart } from "modules/Auth/redux/logout";

class authHttp extends HttpClient {
  private static classInstance?: authHttp;
  private constructor() {
    super(REACT_APP_RESTFUL_BASE_URL_FOT_API, {
      onLogout: (payload) => {
        store.dispatch(logoutStart({ toastMsg: payload?.toastMsg ?? "" }));
      },
    });
  }

  public static getInstance() {
    if (!this.classInstance) {
      this.classInstance = new authHttp();
    }
    return this.classInstance;
  }
}

const authHttpService = authHttp.getInstance();
export default authHttpService;
